import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../../ui/card';
import { CheckCircle2 } from 'lucide-react';

const RoadmapSlide = ({ data }) => {
  const quarterColors = [
    'from-cyan-500/20 to-cyan-600/20 border-cyan-500/30',
    'from-teal-500/20 to-teal-600/20 border-teal-500/30',
    'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
    'from-sky-500/20 to-sky-600/20 border-sky-500/30',
  ];

  const dotColors = ['bg-cyan-400', 'bg-teal-400', 'bg-emerald-400', 'bg-sky-400'];

  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Timeline */}
      <div className="relative">
        {/* Line */}
        <div className="absolute top-8 left-0 right-0 h-1 bg-gradient-to-r from-cyan-500 via-teal-500 via-emerald-500 to-sky-500 hidden md:block" />
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {data.quarters.map((quarter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + index * 0.15 }}
              className="relative"
            >
              {/* Dot */}
              <div className={`hidden md:block absolute top-6 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full ${dotColors[index]} border-4 border-slate-900`} />
              
              <Card className={`bg-gradient-to-br ${quarterColors[index]} p-5 mt-12 md:mt-16 h-full`}>
                <h3 className="text-xl font-bold text-white mb-4">{quarter.q}</h3>
                <ul className="space-y-2">
                  {quarter.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-slate-300">
                      <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
                      {item}
                    </li>
                  ))}
                </ul>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoadmapSlide;
